import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { AdminUser } from '~/types/admin-user'
import { UserDetailDialog } from './components/user-detail-dialog'
import { UserGrantPointsDialog } from './components/user-grant-points-dialog'
import { UserRoleDialog } from './components/user-role-dialog'
import { UsersList } from './components/users-list'

export function UsersPage() {
  const { t } = useTranslation()
  const [selectedUser, setSelectedUser] = useState<AdminUser | null>(null)

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold" id="users-title">
        {t('users.title')}
      </h1>
      <UsersList onViewDetail={setSelectedUser} />
      <UserDetailDialog user={selectedUser} />
      <UserGrantPointsDialog targetUser={selectedUser} />
      <UserRoleDialog targetUser={selectedUser} />
    </div>
  )
}
